import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// DIVIDEND BANK PAYMENT RELATED APIs
// ==============================================

// 1. Get Approved Distributions for Payment (GET)
export const getApprovedDistributionsForPayment = async () => {
    try {


        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetApprovedDistributionsForPayment`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Insert Dividend Bank Payment (POST)
export const insertDividendBankPayment = async (params) => {
    try {

        // Validate required parameters
        if (!params.distributionId) {
            throw new Error('Distribution ID is required');
        }
        if (!params.bankId) {
            throw new Error('Bank ID is required');
        }
        if (!params.paymentMode) {
            throw new Error('Payment Mode is required');
        }
        if (!params.paymentDate) {
            throw new Error('Payment Date is required');
        }
        if (!params.userId) {
            throw new Error('User ID is required');
        }
        if (!params.remarks) {
            throw new Error('Remarks are required');
        }

        // ✅ Use PascalCase to match C# model properties
        const payload = {
            DistributionId: parseInt(params.distributionId),              
            BankId: parseInt(params.bankId),                              
            PaymentMode: params.paymentMode.toString().trim(),            
            ChequeNo: params.chequeNo?.toString().trim() || '',           
            ChequeDate: params.chequeDate || null,                        
            PaymentDate: params.paymentDate,                              
            UserId: params.userId.toString().trim(), 
            RoleId: parseInt(params.roleId),                     
            Remarks: params.remarks.toString().trim()                     
        };


        const response = await axios.post(
            `${API_BASE_URL}/Accounts/InsertDividendBankPayment`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Approve/Verify/Reject Dividend Bank Payment (PUT)
export const approveDividendBankPayment = async (params) => {
    try {

        // Validate required parameters
        if (!params.transactionRefno) {
            throw new Error('Transaction Reference Number is required');
        }
        if (!params.roleid) {
            throw new Error('RoleId is required');
        }
        if (!params.action) {
            throw new Error('Action is required');
        }
        if (!params.createdby) {
            throw new Error('Createdby is required');
        }

        // ✅ Use PascalCase to match C# model
        const payload = {
            TransactionRefno: parseInt(params.transactionRefno),  // Capital T, R
            Roleid: parseInt(params.roleid),                      // Capital R
            Action: params.action.toString().trim(),              // Capital A
            Note: params.note?.toString().trim() || '',           // Capital N
            Createdby: params.createdby.toString().trim()         // Capital C
        };


        const response = await axios.put(
            `${API_BASE_URL}/Accounts/ApproveDividendBankPayment`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Get Verify Dividend Bank Payment Inbox (GET)
export const getVerifyDividendBankPayment = async (params) => {
    try {
        const { roleId } = params;

        // Validate required parameters
        if (!roleId) {
            throw new Error('RoleID is required');
        }


        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetVerifyDividendBankPayment/${roleId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 5. Get Dividend Bank Payment by Reference Number (GET)
export const getDividendBankPaymentByRefno = async (params) => {
    try {
        const { transactionRefno } = params;

        // Validate required parameters
        if (!transactionRefno) {
            throw new Error('Transaction Reference Number is required');
        }


        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetDividendBankPaymentByRefno/${transactionRefno}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};